module.exports = __webpack_public_path__ + "media/icons/pro@2x-ca5e67bd.png";